import { apiClient } from './client';
import type { PlayableType } from './types';

export const playables = {
  async bump(playableType: PlayableType): Promise<void> {
    try {
      await apiClient.post(`/playables/${playableType}/bump/`);
    } catch (error) {
      console.error(`Failed to bump ${playableType} playable:`, error);
      throw error;
    }
  }
};
